import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface ChangeEndpointDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  baseUrl: string;
  setBaseUrl: (value: string) => void;
  tenant: string;
  setTenant: (value: string) => void;
}

const ChangeEndpointDialog: React.FC<ChangeEndpointDialogProps> = ({
  open,
  onClose,
  onSave,
  baseUrl,
  setBaseUrl,
  tenant,
  setTenant
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Change Endpoint</DialogTitle>
    <DialogContent>
      <TextField
        label="Base URL"
        value={baseUrl}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBaseUrl(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Tenant"
        value={tenant}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTenant(e.target.value)}
        fullWidth
        margin="normal"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSave} variant="contained">Save</Button>
    </DialogActions>
  </Dialog>
);

export default ChangeEndpointDialog; 